import React, { FC, useContext, useState } from 'react';
import { useDebounce } from 'react-use';
import { Autocomplete, TextField } from '@mui/material';

import { truncate } from 'lodash';
import { LocalizationContext } from 'contexts';
import { useOriginalItemSearchResults } from 'shared/hooks/useOriginalItemSearchResults';
import { useQueryState } from 'shared/hooks/useQueryState';

export const BlockSearchAutocomplete: FC<any> = ({ label, TextFieldProps, ...props }) => {
  const { dictionary } = useContext(LocalizationContext);
  const [ slug = '' ] = useQueryState('slug');
  const [searchQuery, setSearchQuery] = useState('');
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
  const { results } = useOriginalItemSearchResults({ cla_slug: slug, search: debouncedSearchQuery }, { enabled: debouncedSearchQuery.length > 2 });

  useDebounce(() => {
    setDebouncedSearchQuery(searchQuery);
  },
  500,
  [searchQuery],
  );

  return (
    <Autocomplete
      options={results}
      renderInput={props => (
        <TextField
          {...props}
          label={label || dictionary.faq.searchBlocks}
          InputLabelProps={{ shrink: true }}
          {...TextFieldProps}
          onChange={(event) => setSearchQuery(event.target.value)}
        />
      )}
      getOptionLabel={(block: any) => block.stripped_title_draft || block.stripped_title || truncate((block.stripped_text_content_draft || block.text_content), { length: 15 } )}
      {...props}
      onChange={(e, value) => props.onChange(value)}
    />
  );
};
